export const gtmConfig = {
  containerId: process.env.REACT_APP_GTM_CONTAINER_ID,
}
